const keysMap = {
    sku : 'SKU',
    price: 'Price',
    description: 'Description',
    short_description: 'Short Description',
    accessories_01: 'Accessory 01',
    accessories_02: 'Accessory 02',
    primary_camera: 'Primary Camera',
    manufacturer: 'Brand',
    battery_capacity: 'Battery Capacity',
    secondary_camera: 'Secondary Camera'
}

export default keysMap;